import { ArrowUpRight, TriangleAlert } from "lucide-react";
import { Link } from "react-router-dom";
import { usePlan } from "../context/PlanContext";

export function PlanLimitBanner({ resource }) {
  const { plan } = usePlan();
  const state = plan?.resources?.[resource];
  if (!state?.limit || (!state.warning && !state.reached)) return null;

  return (
    <div className={`plan-banner ${state.reached ? "is-blocked" : ""}`} data-testid={`plan-banner-${resource}`}>
      <TriangleAlert size={16} />
      <span>
        {state.reached
          ? `Limite raggiunto: il piano ${plan.plan_name} include ${state.limit} ${state.limit === 1 ? state.label_one : state.label} e ne hai ${state.used}.`
          : `Hai usato ${state.used} ${state.label} su ${state.limit} del piano ${plan.plan_name}.`}
      </span>
      <Link to="/piano" data-testid={`plan-banner-cta-${resource}`}>Vedi i piani <ArrowUpRight size={13} /></Link>
    </div>
  );
}
